module.exports = __webpack_public_path__ + "static/img/logo_big.f33cdad9.png";